import debounce from 'es6-promise-debounce/src/es6-promise-debounce';

export default class Calculator {
    constructor(formElement) {
        this.form = jQuery(formElement);
        this.currencies = {
            gbp: {
                key: 'gbp',
                symbol: '£',
                text: 'Pounds',
            },
            eur: {
                key: 'eur',
                symbol: '€',
                text: 'Euros',
            },
        };
        this.currency = this.currencies.eur;
        this.switchCurrency();

        const debouncedFunction = debounce(() => {
            return new Promise((resolve) => {
                resolve();
            });
        }, 300);

        this.form.find('input').on('keyup', () => {
            debouncedFunction().then(() => {
                this.run();
            });
        });

        this.form.find('select').not('#truck').on('change', () => {
            this.run();
        });

        this.form.find('#truck').on('change', (event) => {
            jQuery.ajax(this.form.attr('action'), {
                data: { truck: jQuery(event.currentTarget).val(), action: 'costs' },
                type: this.form.attr('method'),
                dataType: 'json',
                success: (data) => {
                    jQuery('input[name=fitting-cost]').val(data.fitting_cost);
                    jQuery('input[name=fuel-saving]').val(data.savings);
                },
                error: (error) => {
                    console.log('Failed', error);
                },
            });
        });

        jQuery('.reset').on('click', (event) => {
            event.preventDefault();
            this.form.get(0).reset();
        });
    }

    switchCurrency() {
        jQuery('.currency-switch').find('.currency').text(`${this.currency.symbol} ${this.currency.text}`);
        if (this.currency.symbol === '£') {
            this.currency = this.currencies.eur;
        } else {
            this.currency = this.currencies.gbp;
        }

        this.form.find('.currency').text(this.currency.symbol);
        this.form.find('input[name=currency]').val(this.currency.key);
        this.run();
    }

    run() {
        jQuery.ajax(this.form.attr('action'), {
            data: this.form.serialize(),
            type: this.form.attr('method'),
            dataType: 'json',
            success: (data) => {
                jQuery('#months').val(data.months);
                jQuery('#price').val(data.price);
            },
            error: (error) => {
                console.log('Failed', error);
            },
        });
    }

}



// WEBPACK FOOTER //
// ./scripts/app/calculator.js